import { defineComponent as _defineComponent } from 'vue'
import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, createBlock as _createBlock, createElementVNode as _createElementVNode, createCommentVNode as _createCommentVNode, withCtx as _withCtx, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-1e679e58"),n=n(),_popScopeId(),n)
const _hoisted_1 = { key: 0 }
const _hoisted_2 = { class: "list-wrap" }

import { ref, reactive, defineAsyncComponent, computed,watch } from 'vue'
import { useStore } from 'vuex'
import { Options, Vue } from 'vue-class-component'
import { useRoute } from 'vue-router'
import qs from 'qs'
import SimpleTab from '@/components/SimpleTab.vue'
import QuickPublishNews from '@/components/QuickPublishNews.vue'
import BlockSuggestProject from '@/components/BlockSuggestProject.vue'
import ItemApp from '@/components/ItemApp.vue'
import { Api } from '@/services/http'


export default /*#__PURE__*/_defineComponent({
  __name: 'AppComponent',
  setup(__props) {

const route = useRoute()
const store = useStore()
const keyword = ref('')
const tabIndex = ref(0)


const pageData = reactive({
  businessItems:[],
  list:[],
  
  
})
const reset = ()=>{
  keyword.value =''
  tabIndex.value = 0
  pageData.news = {
    list:null,
    pagination: {
      current:1,
      total: 1,
    }
  }
  pageData.match = {
    list:null,
    pagination: {
      current:1,
      total: 1,
    }
  }
  pageData.lecture = {
    list:null,
    pagination: {
      current:1,
      total: 1,
    }
  }
  handleSearch(null)
}

//** 行业数据载入 */
const businessItems  = computed(() => {
  return store.state.base.businessItems;
})
const optionsTabs = computed(()=>{
  let items = [];
  if( pageData.businessItems.length ){
    items = pageData.businessItems
  }
  if( store.state.base.businessItems.length ){
    items = store.state.base.businessItems
  }

  const find = items.find(item=> item.type =='tool_type')
  if( find ){
    return find.items;
  }else{
    return []
  }
})
watch(businessItems, newData => {
  pageData.businessItems = [...newData];
  handleSearch(null);
})


const handleKeyword = e => {
  keyword.value = e.target.value
  if (e.keyCode == 13) {
    handleSearch(e)
  }
}


const handleChange = index => {
  tabIndex.value = index
  handleSearch();
}
const handlePage = page => {
  const index = tabIndex.value
  pageData.list[index].pagination.current = page;
  handleSearch();
}

const handleSearch = async (e: any) => {
  const index = tabIndex.value
  let pgData: any = { ...pageData }
  if( ! pgData.list[index]){
    pgData.list[index] = {
      list:[],pagination:{total:0,current:1,size:15}
    }
  }
  
  const pagination = pgData.list[index].pagination || {}
  console.log('optionsTabs',optionsTabs)
  if( !optionsTabs.value.length){
    return;
  }
  const toolType = optionsTabs.value[index].value
  const payload = {
    toolType,
    searchStr: keyword.value,
    current: pagination.current,
    size: pagination.size,
  }
  const data = await Api.post(`/client-api/toolbox/list`, qs.stringify(payload))
  pageData.list[index].list = data.list
  pageData.list[index].pagination.total = data.total
  console.log('pageData', pageData)
}
const mounted = async () => {
  handleSearch(null)
}
mounted()

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(SimpleTab, {
    class: "subtab app-comp",
    onChange: handleChange
  }, {
    tabs: _withCtx(() => [
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(optionsTabs.value, (item, index) => {
        return (_openBlock(), _createElementBlock("div", {
          class: _normalizeClass(`li tab-item ${tabIndex.value == index ? 'current' : ''}`),
          key: index
        }, _toDisplayString(item.label), 3))
      }), 128))
    ]),
    contents: _withCtx(() => [
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(optionsTabs.value, (item, index) => {
        return (_openBlock(), _createElementBlock("div", {
          class: _normalizeClass(`content-item ${tabIndex.value == index ? 'current' : ''}`),
          key: index
        }, [
          (pageData.list[index] && pageData.list[index].list)
            ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
                _createElementVNode("div", _hoisted_2, [
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(pageData.list[index].list, (app, index) => {
                    return (_openBlock(), _createBlock(ItemApp, {
                      data: app,
                      key: app.id
                    }, null, 8, ["data"]))
                  }), 128))
                ])
              ]))
            : _createCommentVNode("", true)
        ], 2))
      }), 128))
    ]),
    _: 1
  }))
}
}

})